import { Injectable } from '@angular/core';
import { AuthService } from '../../../../shared/services/auth/auth.service';

enum MailStatus {
  CREATED = 'created',
  READY_TO_DELIVER = 'ready to deliver',
  DELIVERED = 'delivered',
  ERROR = 'error'
}

@Injectable()
export class BPProfilesMailsService {

  constructor(
    private authService:AuthService
  ) {
    /**/
  }

  public formatMailStatusLabelClass(status:string):string {
    switch (status?.toLowerCase()) {
      case MailStatus.CREATED:
      case MailStatus.READY_TO_DELIVER:
        return 'bg-primary';
      case MailStatus.DELIVERED:
        return 'bg-success';
      case MailStatus.ERROR:
        return 'bg-danger';
      default:
        return 'bg-secondary';
    }
  }

  public formatNewMailUrl(mailToUrl:string, companyCountryId?:string):string {
    let baseUrl:string = `${mailToUrl}&browseList=true`;
    baseUrl = baseUrl.replace('{Deccoid}', companyCountryId || '');
    baseUrl = baseUrl.replace('{Deconid}', '');
    return this.authService.authenticatedUrl(baseUrl);
  }
}